<template>
  <section class="container-section">
    <div class="sub-container">
      <section class="section-titles">
        <h3 class="title">
          Logística de Envío
        </h3>
      </section>
      <section>
        <div class="items">
          <label style="cursor: pointer">
            <input
              v-model="selectionShippingLogistics.isPickingAndPacking"
              name="isPickingAndPacking"
              class="uk-checkbox"
              type="checkbox"
            > Picking and Packing / Etiquetado especifico
          </label>
        </div>
        <div
          v-if="showItem"
        >
          <div
            style="padding-bottom: 10px"
            class="uk-flex items uk-flex-wrap"
          >
            <div class="uk-margin-right uk-flex uk-flex-column uk-flex-center">
              <label style="cursor: pointer">
                <input
                  v-model="selectionShippingLogistics.isConsolidationTemporaryStorage"
                  class="uk-checkbox"
                  type="checkbox"
                  @change="selectionShippingLogistics.consolidationTemporaryStorageMonths = 0"
                > Consolidación y Almacenaje Temporal
              </label>
            </div>
            <div
              class="uk-flex"
              style="margin-top: 5px"
            >
              <input
                v-model="selectionShippingLogistics.consolidationTemporaryStorageMonths"
                :disabled="!selectionShippingLogistics.isConsolidationTemporaryStorage"
                min="0"
                max="9999999"
                class="uk-input uk-form-width-xsmall"
                style="width: 70px; margin-right: 5px"
                type="number"
                @keydown="$helperPlugin.onlyNumber($event)"
              >
              <label class=" uk-flex uk-flex-column uk-flex-center"> No. de Meses</label>
            </div>
          </div>

          <div
            v-if="(transportMode !== transportModeTypeEnum.aerial || dollyType !== dollyTypeEnum.reefer)"
            class="items"
          >
            <label style="cursor: pointer">
              <input
                v-model="selectionShippingLogistics.isCarriageVergeConsolidation"
                name="isCarriageVergeConsolidation"
                class="uk-checkbox"
                type="checkbox"
              > Acarreo Apuntos de Consolidación
            </label>
          </div>
          <div
            v-if="selectionShippingLogistics.isCarriageVergeConsolidation == true"
          >
            <div
              class="items"
            >
              <label class="uk-margin items-label">
                <input
                  v-model="selectionShippingLogistics.averageHaulingDistance"
                  class="uk-input uk-form-width-small"
                  type="number"
                  min="0"
                  max="9999999"
                  @keydown="$helperPlugin.onlyDecimal($event)"
                >
                <span> -Km (Distancia Promedio de Acarreo)</span>
              </label>
            </div>
            <div
              class="items"
            >
              <label class="items-label">
                <input
                  v-model="selectionShippingLogistics.TravelCarriageNecessary"
                  class="uk-input uk-form-width-small"
                  type="number"
                  min="0"
                  max="9999999"
                  @keydown="$helperPlugin.onlyNumber($event)"
                >
                <span>-No. Viajes Acarreos Necesarios</span>
              </label>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="btn">
      <wizard-button />
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { transportModeTypeEnum, dollyTypeEnum, directionTypeEnum } from '../../../types'
export default {
  data () {
    return {
      directionTypeEnum,
      transportModeTypeEnum,
      dollyTypeEnum,
      selectionShippingLogistics: {
        isPickingAndPacking: null,
        isConsolidationTemporaryStorage: null,
        consolidationTemporaryStorageMonths: null,
        isCarriageVergeConsolidation: null,
        TravelCarriageNecessary: null,
        averageHaulingDistance: null
      },
      showItem: false
    }
  },
  computed: {
    ...mapGetters([
      'shippingLogisticsStore',
      'journeyDirection',
      'transportMode',
      'dollyType'
    ])
  },
  watch: {
    selectionShippingLogistics: {
      handler: function (newVal) {
        this.$store.commit('setShippingLogistic', newVal)
      },
      deep: true
    },
    'selectionShippingLogistics.TravelCarriageNecessary': async function (newVal, oldVal) {
      if (this.selectionShippingLogistics.TravelCarriageNecessary > 9999) this.selectionShippingLogistics.TravelCarriageNecessary = oldVal
    },
    'selectionShippingLogistics.averageHaulingDistance': async function (newVal, oldVal) {
      if (this.selectionShippingLogistics.averageHaulingDistance > 9999999) this.selectionShippingLogistics.averageHaulingDistance = oldVal
    },
    'selectionShippingLogistics.consolidationTemporaryStorageMonths': async function (newVal, oldVal) {
      if (this.selectionShippingLogistics.consolidationTemporaryStorageMonths > 9999) this.selectionShippingLogistics.consolidationTemporaryStorageMonths = oldVal
    }
  },
  mounted () {
    this.selectionShippingLogistics = { ...this.shippingLogisticsStore }
    this.isShow()
  },
  methods: {
    isShow () {
      if (this.transportModeTypeEnum.maritime === this.transportMode) {
        this.showItem = true
      } else if (this.transportModeTypeEnum.aerial === this.transportMode && this.directionTypeEnum.export === this.journeyDirection && this.dollyTypeEnum.reefer === this.dollyType) {
        this.showItem = true
      }
    }
  }

}
</script>

<style scoped>

section{
  padding: 10px;
  width: 100%;
}
.container-section{
  padding: 10px 40px
}
.title{
  font-weight: 600;
  margin-bottom: 10px;

}

.sub-container{
  min-height: 418px;;
}

.section-titles{
  width: 85%;
  padding: 0px
}
.btn{
  padding-right:25px ;
}

.opt{
  font-size: 12px;
  color: rgb(151, 151, 151);
}
.items{
  margin-bottom: 30px ;
}
.items-label{
  display: flex;
  align-items: baseline;
}
.items-label span{
  margin-left: 4px;
}
@media screen and (max-width: 879px){
  .section-titles{
    width: 100%;
  }
  .main{
    padding: 10px;
  }
  .title{
    font-size: 17px;
  }
  .helper{
    font-size: 11px;
    margin: 0px
  }

  *{
    font-size: 12px;
  }
  .container-section{
    padding: 10px 20px;
  }

}

@media screen and (max-width: 689px){
  .title{
    font-size: 13px;
  }
  *{
    font-size: 10px;
  }
  .opt{
    font-size: 10px;
  }

  .helper{
    font-size: 10px;
  }

}
@media screen and (max-width: 389px){
.items-label{
  display: flex;
  flex-direction: column;
}
.items-label span{
  margin-bottom: 2px;
  margin-left:0px
}
.items-label input{
  order: 2
}
}
</style>
